import { Component, OnInit, Input } from '@angular/core';
import { ArticleService } from './services/article.service';
import { Blog } from 'src/app/models/article';
import { environment } from 'src/environments/environment';
import { ActivatedRoute, Route } from '@angular/router';

@Component({
  selector: 'app-articles',
  templateUrl: './articles.component.html',
  styleUrls: ['./articles.component.css'],
})
export class ArticlesComponent implements OnInit {
  @Input() language!: string;
  articles: Blog[] = [];
  isLoading = true;
  lang: string = 'ar';

  constructor(
    private articleService: ArticleService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.lang = this.route.snapshot.paramMap.get('lang') ?? 'ar';
    this.articleService.getAllArticles().subscribe({
      next: (articles) => {
        this.articles = articles.filter((articles) =>
          articles.status == 'published'
        ).map((articles) => ({
          ...articles,
          imageUrl: environment.baseURL + articles.imageUrl
        }))
      
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
      },
    });
  }
  getArticleUrl(article: Blog): string {
    return `/${this.lang}/articles/${article.blogId}`;
  }
}
